import React from 'react';
import { Popover } from 'antd';
import { node as nodeElement, object } from 'prop-types';

import { truncate } from '../../../utils';

import {
  ContentWrapper,
  InfoWrapper,
  Key,
  Value,
  StyledLink,
} from '../../../components/ui-helpers';

export const OptionPopover = ({ children, talent }) => (
  <Popover
    trigger="hover"
    placement="bottomLeft"
    overlayStyle={{ zIndex: 1200 }}
    content={
      <ContentWrapper>
        <div>
          <InfoWrapper>
            <Key>Prof. Direction:</Key>
            <Value>{talent.profDirection && truncate(talent.profDirection)}</Value>
          </InfoWrapper>

          <InfoWrapper>
            <Key>Stack:</Key>
            <Value>{talent.stack && truncate(talent.stack)}</Value>
          </InfoWrapper>
        </div>
        <StyledLink
          target="_blank"
          href={talent.url}
        >
          Open talent
        </StyledLink>
      </ContentWrapper>
    }
  >
    {children}
  </Popover>
);

OptionPopover.propTypes = {
  talent: object.isRequired,
  children: nodeElement.isRequired,
};

OptionPopover.defaultProps = {};



// WEBPACK FOOTER //
// ./src/modals/manage-talents-modal/talent-info-popover/index.js